import { Fragment, useState, memo } from "react";
import config from "../configuration/config";

/**
 * ServiceBox Component
 * A premium card used to display categorized services or parts.
 * Styled via: src/pages/parts/css/serviceBox.css
 */
export const ServiceBox = memo(function ServiceBox({
    key = null,
    titlebtn,
    link,
    img,
    imgUrl = "",
    titleEn = " ",
    titleAr = " ",
    extraClass = "",
}) {
    const [lang] = useState(localStorage.getItem("i18nextLng"));
    const titel = lang === "en" ? titleEn : titleAr;

    const fallback =
        lang === "ar"
            ? "/assets/images/parts/PARTS_TOYOTA-AR-no-img.png"
            : "/assets/images/parts/PARTS_TOYOTA-EN-no-img.png";

    let imageSrc = fallback;
    if (imgUrl && imgUrl !== "null" && imgUrl !== "") {
        imageSrc = config.controllURL + imgUrl;
    } else if (img && img !== "null") {
        imageSrc = "data:image/png;base64," + img;
    }

    const handleImageError = (e) => {
        e.target.onerror = null;
        e.target.src = fallback;
    };

    const handleLinkClick = (e) => {
        if (link == null || link === undefined) e.preventDefault();
    };

    return (
        <Fragment key={key}>
            <a
                href={link ?? "#"}
                className={`pt-service-card ${extraClass}`}
                onClick={handleLinkClick}
                aria-label={titel}
            >
                {/* 1. Image Area with Skeleton Loader */}
                <div className="pt-service-card__img-wrap">
                    <div className="pt-service-card__skeleton"></div>
                    <img
                        src={imageSrc}
                        alt={titel}
                        className="pt-service-card__img"
                        loading="lazy"
                        onError={handleImageError}
                        onLoad={(e) => {
                            e.target.style.opacity = "1";
                        }}
                    />
                </div>

                {/* 2. Text Area with Truncation */}
                <h3 className="pt-service-card__title">{titel}</h3>

                {/* 3. Optional Action Button */}
                {link && titlebtn && (
                    <div className="pt-service-card__btn-wrap">
                        <span className="btn btn-primary pt-cta-btn">
                            {titlebtn}
                        </span>
                    </div>
                )}
            </a>
        </Fragment>
    );
});